import { SelectionIconButton as _SelectionIconButton } from './SelectionIconButton.component';
import { SelectionIconButtonLoader } from './SelectionIconButtonLoader';

export const SelectionIconButton = Object.assign(_SelectionIconButton, {
  Loader: SelectionIconButtonLoader,
});
